export const isPassword = (val, optional) =>
  !optional && !val
    ? 'Please enter a password'
    : val.length < 10
    ? 'The password must be at least 10 characters long'
    : null;
